import ProviderVariantAdd from "./add";

export default ProviderVariantAdd;
